import { NgModule } from '@angular/core';

import { MasterVisualizarUsuarioActions } from './master-visualizar-usuario.actions';
import { FecharAction } from './master-fechar-visualizar-usuario.action';

@NgModule({
  providers: [
      FecharAction,
    MasterVisualizarUsuarioActions
  ]
})
export class MasterVisualizarUsuarioActionsModule {}
